import { Typography, Link } from '@one-thd/sui-atomic-components';
import { Store, QRCode, BuyAgain } from '@one-thd/sui-icons';
import React, { useEffect } from 'react';
import { ReturnButtons } from '../../shared/ReturnButtons';
import { disableAbandonmentSurvey } from '../../../utils/storage-helper';
import { useReturnStore } from '../../../stores/returnStore';
import { redirectToOrderDetails } from '../../../utils/general';
import OrderNumberBarcode from '../OrderNumberBarcode';

export const Phase0InStoreReturnMethod = () => {
  const isMilitaryExchangeGuest = useReturnStore(
    (state) => state.isMilitaryExchangeGuest,
  );
  const orderDetailsPath = useReturnStore((state) => state.orderDetailsPath);
  const isPTCOrder = useReturnStore((state) => state.isPTCOrder);
  const refundTimingAmount = isPTCOrder ? '1 business day' : '10 business days';
  const inStoreRefundTimingMessage = `It may take up to ${refundTimingAmount} for your bank to put the funds back into your account.`;

  useEffect(() => {
    disableAbandonmentSurvey(); // Safety net to make sure survey is disabled
  }, []);

  return (
    <div className="sui-max-w-xl" data-testid="phase0-instore">
      <div className="sui-mb-4">
        <Typography weight="bold">In-Store Drop-Off Instructions</Typography>
      </div>

      <OrderNumberBarcode />

      <div className="sui-mb-4 sui-flex sui-gap-3">
        <div className="sui-pt-[6px]">
          <Store />
        </div>

        <Typography>
          Take your return items to any{' '}
          <Link href="https://www.homedepot.com/l/" target="_blank">
            Home Depot store.
          </Link>
        </Typography>
      </div>
      <div className="sui-mb-4 sui-flex sui-gap-3">
        <div className="sui-pt-[6px]">
          <QRCode />
        </div>

        <Typography>
          Show your barcode
          {!isMilitaryExchangeGuest && (
            <>, receipt or the card used at purchase</>
          )}{' '}
          to an associate at the returns counter.
        </Typography>
      </div>
      <div className="sui-flex sui-gap-3">
        <div className="sui-pt-[6px]">
          <BuyAgain />
        </div>

        <Typography>{inStoreRefundTimingMessage}</Typography>
      </div>

      <ReturnButtons
        proceedNext={() =>
          redirectToOrderDetails(orderDetailsPath, isMilitaryExchangeGuest)
        }
        instore
      />
    </div>
  );
};
